module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/consigner.27e7fa7c.svg";